// Escapa texto antes de interpolar em HTML montado via template literal (paginas de impressao
// abertas com window.open + document.write) — sem isso, um nome de cliente/seguradora/etc. com
// caracteres de HTML vira codigo executavel na pagina de impressao (XSS armazenado).
export function escapeHtml(valor) {
  if (valor == null) return ''
  return String(valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
